<template>
  <a-mentions
    :value="value"
    :filter-option="filterOption"
    :placeholder="placeholder"
    :loading="isLoading"
    :rows="rows"
    @blur="onBlur"
    @change="onChange"
    @search="onSearch"
    @select="onSelect"
  >
    <a-mentions-option
      v-for="user in users"
      :key="user.uid"
      :user-id="user.uid"
      :value="user.nickname || user.name"
    >
      <MentionUser
        :user="user"
      />
    </a-mentions-option>
  </a-mentions>
</template>

<script>
import debounce from 'lodash/debounce'
import { ref, toRefs, toRaw } from 'vue'
import { useStore } from 'vuex'
import assign from 'lodash/assign'

import { searchUser, searchUserFromAll } from '@/api/user'
import MentionUser from '@/components/MentionUser'

export default {
  name: 'MentionTextArea',
  components: {
    MentionUser
  },
  props: {
    value: {
      type: String,
      default: undefined
    },
    formItemRef: {
      type: Object,
      default: () => undefined
    },
    mentionedUserIds: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    rows: {
      type: Number,
      default: 6
    },
    searchRange: {
      type: String,
      default: ''
    }
  },
  emits: [
    'blur',
    'update:value'
  ],
  setup (props, { emit }) {
    const { state, commit } = useStore()
    const isLoading = ref(false)
    const searchValue = ref('')
    const users = ref([])
    const { mentionedUserIds } = toRefs(props)
    const frequentContacts = state.users.slice(0, 101)
      .filter(userItem => userItem.uid !== state.user.uid)
      .slice(0, 100)
    const searchFn = props.searchRange === 'ALL' ? searchUserFromAll : searchUser

    const loadUsers = debounce(keyword => {
      searchFn(keyword)
        .then(usersRaw => {
          // 如果在搜索的过程中用户又输入了新的关键词，则不显示原来的搜索结果
          if (keyword !== searchValue.value) {
            return
          }
          users.value = usersRaw
          isLoading.value = false
        })
    }, 500)

    function onSearch (keyword) {
      searchValue.value = keyword
      isLoading.value = !!keyword
      users.value = []
      if (!keyword) {
        users.value = frequentContacts
        return
      }

      loadUsers(keyword)
    }

    function onBlur () {
      emit('blur')
      if (props.formItemRef) {
        props.formItemRef.onFieldBlur()
      }
    }

    function onChange (value) {
      emit('update:value', value)
      if (props.formItemRef) {
        props.formItemRef.onFieldChange()
      }
    }

    function onSelect (option) {
      // TODO 有没有更好地获取用户信息的方式？
      const user = option.children[0].props.user
      commit('ADD_USERS', assign({ id: user.uid }, toRaw(user)))
      mentionedUserIds.value.push(user.uid)
    }

    function filterOption (input, option) {
      const myUserId = option.children[0].props.user.uid
      return myUserId !== state.user.uid
    }

    return {
      isLoading,
      users,
      onBlur,
      onChange,
      onSearch,
      onSelect,
      filterOption
    }
  }
}
</script>
